module.exports = function supportsMediaRecorder() {
  return typeof MediaRecorder === 'function' && !!MediaRecorder.prototype && typeof MediaRecorder.prototype.start === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/webcam/lib/supportsMediaRecorder.js
// module id = 1886
// module chunks = 2